import { Container, Row, Col, Card } from "react-bootstrap";

export default function TechnicalServices() {
  return (
    <Container fluid className="py-5 bg-white">
      <h2 className="text-center text-primary fw-bold">Technical Services</h2>
      <p className="mt-3 text-center text-secondary fs-5">
        Delivering cutting-edge engineering, consulting, and project management services for infrastructure development.
      </p>

      <Row className="mt-4 justify-content-center g-4">
        <Col xs={12} md={6} lg={4}>
          <Card className="shadow border-0" style={{padding: "5px" }}>
            <Card.Body>
              <Card.Title className="text-primary fw-bold">Structural Engineering</Card.Title>
              <Card.Text className="text-secondary">
                Providing advanced structural design solutions for complex projects.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} md={6} lg={4}>
          <Card className="shadow border-0" style={{padding: "5px" }}>
            <Card.Body>
              <Card.Title className="text-primary fw-bold">Project Management</Card.Title>
              <Card.Text className="text-secondary">
                Ensuring seamless execution of infrastructure projects with expert management.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
